import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);

    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }

    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => {
        navigate("/admin", { state: { user: res.data }, replace: true });
      })
      .catch((err) => {
        if (err?.response?.status === 403) {
          toast.error("This dashboard is private to JE Training.");
        } else {
          toast.error("Sign-in failed. Please try again.");
        }
        navigate("/admin", { replace: true });
      });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center" data-testid="auth-callback-loading">
      <div className="flex items-center gap-3 text-zinc-400">
        <Loader2 size={20} className="animate-spin text-[#D4AF37]" />
        <span className="font-display text-sm font-bold uppercase tracking-[0.2em]">Signing you in…</span>
      </div>
    </div>
  );
}
